import React, { useState, useEffect, useCallback ,useMemo} from 'react';
import { styled } from '@mui/material/styles';
import TextField from '@mui/material/TextField';
import axios from 'axios';
import Autocomplete from '@mui/material/Autocomplete';
import SearchIcon from '@mui/icons-material/Search';
import InputAdornment from '@mui/material/InputAdornment';
import Modal from "@mui/material/Modal";
import StudentForm from "./studentForm";
import UserForm from "./userForm"; // Import the new component
import debounce from 'lodash.debounce';
import Snackbar from "@mui/material/Snackbar";
import Alert from "@mui/material/Alert";
import Slide from '@mui/material/Slide';
import { CircularProgress } from '@mui/material';
import Portal from '@mui/material/Portal';
import Fade from '@mui/material/Fade';


const Container = styled('div')({
  padding: '5rem',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'flex-start',
});

export default function SearchBox() {
  // const [rows, setRows] = useState([]);
  const [searchQuery, setSearchQuery] = useState('');
  const [suggestions, setSuggestions] = useState([]);
  const [isStudentModalOpen, setIsStudentModalOpen] = useState(false);
  const [isUserModalOpen, setIsUserModalOpen] = useState(false);
  const [selectedStudent, setSelectedStudent] = useState(null);
  const [selectedUser, setSelectedUser] = useState(null);
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [snackbarSeverity, setSnackbarSeverity] = useState("success");
  const [searchOldPaymentData, setSearchOldPaymentData] = useState([])
  // const [gradesSearch, setGradesSearch] = useState([]);
  const [grades, setGrades] = useState([]);
  const [sections, setSections] = useState([]);
  const [gradeNameSearch, setGradeNameSearch] = useState("");
  const [feesSlabSearch, setFeesSlabSearch] = useState("");
  const [sectionNameSearch, setSectionNameSearch] = useState("");
  const [feeSlab, setFeeSlab] = useState([]);
  const [gradeAdmission, setGradeAdmission] = useState([]);
  const [gradeAdmissionNameSearch, setGradeAdmissionNameSearch] = useState("");
  const [userId, setUserId] =useState();
  const [userMail, setUserMail] =useState();
  const [transportFees, setTransportFees] = useState([]);
  const [transportSlabSearch, setTransportSlabSearch] = useState();
  const [loading, setLoading] = useState(false); // Loading state
  const gradeMap = React.useRef(new Map());
  const sectionMap = React.useRef(new Map());
  const feesSlabMap = React.useRef(new Map());
  const transportMap = React.useRef(new Map());
  const studentCache = React.useRef(new Map());



  useEffect(() => {
    const fetchUserData = async () => {
     
        const email = localStorage.getItem('user_email');
        try {
      const response = await axios.post(
            `${process.env.REACT_APP_JHS_DEVELOPMENT}/profile/profiledata`, 
            { email },
            { headers: { 'user_email': email } },
    
            
          );
      
          if (response.status === 200) {
            setUserId(response.data.user.user_id);
            setUserMail(response.data.user.email_id)
          }
        } catch (error) {
          console.error("Error fetching data:", error);
        }
      };
      fetchUserData();
    }, []);
  

  const fetchStudents = async (query) => {
    setLoading(true); // Show loading before API call
    try {
      const response = await axios.get(process.env.REACT_APP_JHS_DEVELOPMENT+`/student/getsearchresult?search=${encodeURIComponent(query)}`);
      const data = response.data.flat();
      setTimeout(() => {
        if (Array.isArray(data)) {
          setSuggestions(data);
        } else {
          console.error('API Response is not an array:', data);
          setSuggestions([]);
        }
      
        setLoading(false); // Hide loading after API response and delay
      }, 100); 
    } catch (error) {
      console.error('Error fetching data:', error);
      setLoading(false);
    }
  };

  // const debouncedFetchStudents = useCallback(debounce(fetchStudents, 300), []);

   // Memoize debounced function so it doesn't re-create on every render
const debouncedFetchStudents = useMemo(
  () => debounce(fetchStudents, 500),
  [fetchStudents] // Only re-create if fetchStudents changes
);

  useEffect(() => {
    if (searchQuery) {
      debouncedFetchStudents(searchQuery);
      
    } else {
      setSuggestions([]);
    }
     // Cleanup function: Cancel pending debounce calls on unmount
  return () => {
    debouncedFetchStudents.cancel();
  };
  }, [searchQuery]);

  const handleCloseStudentModal = () => {
    setSelectedStudent(null);
    setIsStudentModalOpen(false);
  };

  const handleCloseUserModal = () => {
    setSelectedUser(null);
    setIsUserModalOpen(false);
  };

  const handleSearchChange = (event, newValue) => {
    setSearchQuery(newValue);
  };

  const handleSelect = (event, selectedOption) => {
  if (!selectedOption) return;

  if (selectedOption.role_name === "Student") {
    const studentId = selectedOption.id;

    // ↓ open modal immediately — no waiting
    setSelectedStudent(selectedOption);
    setIsStudentModalOpen(true);

    // ↓ use cache if already fetched
    if (studentCache.current.has(studentId)) {
      const cached = studentCache.current.get(studentId);
      setSelectedStudent(cached);
      setSearchOldPaymentData(cached);
      setGradeNameSearch(gradeMap.current.get(cached.grade_id) || "");
      setGradeAdmissionNameSearch(gradeMap.current.get(cached.grade_of_admission) || "");
      setSectionNameSearch(sectionMap.current.get(cached.section_id) || "No section available");
      setFeesSlabSearch(feesSlabMap.current.get(cached.fee_slab_id) || "");
      setTransportSlabSearch(transportMap.current.get(cached.transport_slab_id) || null);
      return;
    }

    // ↓ same axios call — only adds cache store + uses Maps for name resolution
    axios.get(process.env.REACT_APP_JHS_DEVELOPMENT + `/student/getstudentdetails?student_id=${studentId}`, { withCredentials: true })
      .then((response) => {
        studentCache.current.set(studentId, response.data); // ← cache it
        setSelectedStudent(response.data);
        setSearchOldPaymentData(response.data);
        setGradeNameSearch(gradeMap.current.get(response.data.grade_id) || "");
        setGradeAdmissionNameSearch(gradeMap.current.get(response.data.grade_of_admission) || "");
        setSectionNameSearch(sectionMap.current.get(response.data.section_id) || "No section available");
        setFeesSlabSearch(feesSlabMap.current.get(response.data.fee_slab_id) || "");
        setTransportSlabSearch(transportMap.current.get(response.data.transport_slab_id) || null);
      })
      .catch((error) => {
        console.error('Error fetching student details:', error);
      });

  } else {
    // ↓ user flow — completely unchanged
    const userId = selectedOption.id;
    axios.get(process.env.REACT_APP_JHS_DEVELOPMENT + `/student/getuserdetails?user_id=${userId}`, { withCredentials: true })
      .then((response) => {
        setSelectedUser(response.data);
        setIsUserModalOpen(true);
      })
      .catch((error) => {
        console.error('Error fetching user details:', error);
      });
  }
};

// ✅ Single useEffect replacing all 4
useEffect(() => {
  Promise.all([
    axios.get(process.env.REACT_APP_JHS_DEVELOPMENT + "/grade/grade-section", { withCredentials: true }),
    axios.get(process.env.REACT_APP_JHS_DEVELOPMENT + "/fees/getFeeSlab", { withCredentials: true }),
    axios.get(process.env.REACT_APP_JHS_DEVELOPMENT + "/transportPayment/transportSlab", { withCredentials: true }),
  ]).then(([gradeRes, feeRes, transportRes]) => {
    // ── set states ──
    setGrades(gradeRes.data.grades);
    setGradeAdmission(gradeRes.data.grades);
    setSections(
      gradeRes.data.sections.sort((a, b) =>
        a.section_name.localeCompare(b.section_name)
      )
    );
    setFeeSlab(
      feeRes.data.sort((a, b) =>
        a.fees_slab.localeCompare(b.fees_slab, undefined, { numeric: true, sensitivity: "base" })
      )
    );
    setTransportFees(
      transportRes.data.sort((a, b) =>
        a.transport_slab_name.localeCompare(b.transport_slab_name, undefined, { numeric: true, sensitivity: "base" })
      )
    );
    // ── build lookup Maps for O(1) access ──
    gradeRes.data.grades.forEach(g => gradeMap.current.set(g.grade_id, g.grade_name));
    gradeRes.data.sections.forEach(s => sectionMap.current.set(s.section_id, s.section_name));
    feeRes.data.forEach(f => feesSlabMap.current.set(f.fees_slab_id, f.fees_slab));
    transportRes.data.forEach(t => transportMap.current.set(t.transport_slab_id, t.transport_slab_name));
  }).catch((error) => {
    console.error("Error fetching lookup data:", error);
  });
}, []);

  const handleSnackbar = (msg, severity) => {
    console.log("SearchBox snackbar:", msg, severity);
    setSnackbarSeverity(severity);
    setSnackbarMessage(msg);
    setSnackbarOpen(true);
  };

  const handleSubmit = (msg, severity) => {
    setSnackbarSeverity(severity);
    setSnackbarMessage(msg);
    setSnackbarOpen(true);
  };



  return (
    <>
      <Container >
      
        <Autocomplete className='search-box-dashboard' style={{padding:'0'}}
        
          freeSolo
          getOptionLabel={(option) => 
            `${option.id} ${option.first_name} ${option.last_name} ${option.grade_name ? option.grade_name : ""} ${option.section_id ? option.section_id : ""} ${option.role_name ? option.role_name : ""}`}
          // options={suggestions}
          options={loading ? [] : suggestions} 
          inputValue={searchQuery}
          onInputChange={handleSearchChange}
          onChange={handleSelect}
          renderInput={(params) => (
            <TextField
              {...params}
              label="Search..."
              variant="outlined"
              fullWidth
              style={{ marginBottom: '1rem', border: "none" }}
              InputProps={{
                ...params.InputProps,
                startAdornment: (
                  <InputAdornment position="start">
                    <SearchIcon />
                  </InputAdornment>
                ),
                endAdornment: (
                  <InputAdornment position="end">
                    {loading ? <CircularProgress size={24} /> : null}
                  </InputAdornment>
                ),
              }}  
            />
           
          )}
           
          renderOption={(props, option) => (
            <li {...props} style={{alignItems: "center", textAlign:'center'}}>
              <div style={{display:"flex" , justifyContent: 'space-around', width: '100%'}}>
                    <div style={{ flex: 1 }}>{option.id}</div>
                    <div style={{ flex: 1 }}>{option.first_name} {option.last_name}</div>
                    <div style={{ flex: 1}}>{option.grade_name}</div>
                    <div style={{ flex: 1}}>{option.section_id}</div>
                    <div style={{ flex: 1}}>{option.role_name}</div>
                    
              </div>
            </li>
          )}
        />
        
      </Container>
   
  {/* Modal */}
  <Modal open={isStudentModalOpen} onClose={handleCloseStudentModal}>
  <div
    style={{
      padding: 20,
      background: "#fff",
      margin: "5% auto",
      width: "50%",
    }}
  >
    <StudentForm
      studentData={selectedStudent}
      onClose={handleCloseStudentModal}
      handleSubmit={handleSubmit}
      searchOldPaymentData={searchOldPaymentData}
      gradeNameSearch={gradeNameSearch}
      sectionNameSearch={sectionNameSearch}
      feesSlabSearch={feesSlabSearch}
      gradeAdmissionNameSearch={gradeAdmissionNameSearch}
      userId={userId}
      userMail={userMail}
      transportSlabSearch={transportSlabSearch}
      grades={grades}                 
      gradeAdmission={gradeAdmission}  
      sections={sections}             
      feeSlab={feeSlab}                
      transportFees={transportFees} 
    />
  </div>
</Modal>


 <Modal open={isUserModalOpen} onClose={handleCloseUserModal}>
    <div
     style={{
      padding: 20,
    //   background: '#fff',
      margin: '5% auto',
      width: '50%',
      maxHeight: '90vh',
      overflowY: 'auto',
      outline: 'none',  // removes MUI focus ring on the div
    }}
    > 
  <UserForm
            userData={selectedUser}
            handleCloseUserModal={handleCloseUserModal}
            handleSnackbar={ handleSnackbar}
          /></div>
         
      </Modal>

      {/* <Snackbar
        open={snackbarOpen}
        autoHideDuration={4000}
        onClose={() => setSnackbarOpen(false)}
        TransitionComponent={SlideUp}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
        sx={{ zIndex: 999999, position: 'fixed' }}
        ContentProps={{ sx: { zIndex: 999999 } }}
      >
        <Alert elevation={6} variant="filled" severity={snackbarSeverity}>
          {snackbarMessage}
        </Alert>
      </Snackbar> */}

      <Portal>
  <Snackbar
    open={snackbarOpen}
    autoHideDuration={4000}
    onClose={() => setSnackbarOpen(false)}
    TransitionComponent={Fade}
    anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
    sx={{ zIndex: 9999999 }}   // bumped above modal's 1300
  >
    <Alert elevation={6} variant="filled" severity={snackbarSeverity}>
      {snackbarMessage}
    </Alert>
  </Snackbar>
</Portal>

    </>
  );
}